import { Card, Divider, Button } from "antd"
import axios from "axios"
import { useState } from "react"
import { useEffect } from "react"
import { useHistory } from "react-router-dom"
// import { MovieContext } from "../Movies/MovieContext"


const GridMovies = () => {
    const [listOfMovie, setListOfMovie] = useState([]);
    const history = useHistory()
    const HandleSeeMore = () => {
        history.push("/movies")
    }

    const movies = async () => {
        const result = await axios.get("https://super-bootcamp-backend.sanbersy.com/api/movies")
         .then((res)=> res.data)
         .catch((err) => {
             console.log(err)
         })
         const newListMovie = result.slice(0,9)
         setListOfMovie(newListMovie)
     }
    
    useEffect(() => {
        movies()
    }, [])

    const HandleDetail = async (event) => {
        let idMovie = Number(event.target.value)

        history.push(`/movies/${idMovie}/detail`)
    }
    
    return (
        <div style={{marginTop: "100px"}}>
            <Divider orientation="center" style={{fontSize: "30px"}}>
               MOVIES
            </Divider>
            <Card>
                {listOfMovie.map((el)=>
                <Card.Grid key={el.id}>
                <img src={el.image_url} alt="banner-movie" style={{minWidth: "100%", minHeight: "100px"}}></img>
                <h1>{el.title}</h1>
                <button className="button-7" onClick={HandleDetail} value={el.id} >Detail</button>
                </Card.Grid>)}
                <Button style={{margin: "30px auto"}} type="primary" size="large" onClick={HandleSeeMore}>See More</Button>
            </Card>
        </div>
        
    )
}

export default GridMovies